module.exports = __webpack_public_path__ + "static/media/goiteens_logo.9d4c55b1.svg";